import Button from '../../../components/common/Button'

const SuccessStep = ({ formData, onNext }) => {
  return (
    <div className="flex flex-col h-full animate-fade-in">
      {/* Success Message and Next Steps */}
      <div className="flex flex-col justify-between">
        <div className="text-center lg:text-left">
          <div className="flex justify-center lg:justify-start mb-4">
            <div className="bg-green-100 dark:bg-green-900/20 rounded-full p-4">
              <span className="material-icons text-green-600 dark:text-green-400 text-5xl">
                check_circle
              </span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">
            Parabéns!
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            Sua empresa <strong>{formData.validatedCompany?.company_name}</strong> foi ativada com sucesso!
          </p>
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 text-left mb-8 lg:mb-0">
          <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Próximas etapas:</h3>
          <ul className="space-y-2 text-gray-700 dark:text-gray-300 text-sm">
            <li className="flex items-start gap-2">
              <span className="material-icons text-blue-500 flex-shrink-0 text-lg">check_circle</span>
              <span>Você receberá um email com instruções de acesso</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="material-icons text-blue-500 flex-shrink-0 text-lg">arrow_right</span>
              <span>Faça login com o email e senha cadastrados</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Button */}
      <div className="mt-6">
        <Button variant="primary" size="lg" onClick={onNext} className="w-full">
          <span className="material-icons text-sm">login</span>
          Acessar Plataforma
        </Button>
      </div>
    </div>
  )
}

export default SuccessStep
